import { Injectable } from '@angular/core';
import { OauthAEMConfig } from '@com-delta-idp/mnx-oauth';
import { LoggingService } from '@com-delta-idp/mnx-utils';
import { Observable, of } from 'rxjs';
import { catchError, share } from 'rxjs/operators';
import { DEFAULT_ERROR_CODE_LOGIN_BFF } from '../constants/login-constant';
import {
  loginAndGetDashboardRequest,
  loginAndGetDashboardResponse
} from '../models/login-authentication-screen.interface';
import { LoginDasboardService } from './login-dasboard.service';

@Injectable({
  providedIn: 'root'
})
export class LoginResponseService {
  constructor(
    private loginDasboardService: LoginDasboardService,
    private loggingService: LoggingService
  ) {}

  loginResponse!: Observable<loginAndGetDashboardResponse>;
  getLoginResponse(
    authenticationConfig: OauthAEMConfig,
    requestPayload: loginAndGetDashboardRequest,
    tokenResponse?: string
  ): Observable<loginAndGetDashboardResponse> {
    if (this.loginResponse) {
      return this.loginResponse;
    } else {
      this.loginResponse = this.loginDasboardService
        .getDashBrdData(authenticationConfig, requestPayload, tokenResponse)
        .pipe(
          catchError((error) => {
            this.loggingService.log(error);
            return of({
              errors: [
                {
                  code: DEFAULT_ERROR_CODE_LOGIN_BFF
                }
              ]
            } as loginAndGetDashboardResponse);
          }),
          share()
        );
      return this.loginResponse;
    }
  }
}
